module.exports = __webpack_public_path__ + "static/media/interrupted_treatment_mockup.f7014592.png";